import { render, staticRenderFns } from "./team_c.vue?vue&type=template&id=12aa8eb0&"
import script from "./team_c.vue?vue&type=script&lang=js&"
export * from "./team_c.vue?vue&type=script&lang=js&"
import style0 from "./team_c.vue?vue&type=style&index=0&id=12aa8eb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports